/**
 * Turn a stored asset into a browser-loadable image address.
 *
 * Mongo and some API payloads keep only a short filename
 * (`shop_<id>.jpg`, `customer_<id>.jpg`) or a Cloudinary public id
 * (`edgefinances/shop_<id>`). An `<img src>` of that string is a relative
 * path on this site, so the picture never loads. Full http(s) and data URLs
 * are already loadable and are returned unchanged.
 */
const DEFAULT_IMAGE_BASE = 'https://res.cloudinary.com/dxt5ypjhg/image/upload/edgefinances';

function imageBase(): string {
  const raw = String(process.env.REACT_APP_IMAGE_BASE_URL || DEFAULT_IMAGE_BASE).trim();
  return raw.replace(/\/+$/, '');
}

export function mediaSrc(value?: string | null): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;
  const leaf = raw.replace(/^\/+/, '').split('/').filter(Boolean).pop() || raw;
  return `${imageBase()}/${leaf}`;
}
